import { render, staticRenderFns } from "./ExternalePrenotazioniPresaInCaricoListPage.vue?vue&type=template&id=72d42f41"
import script from "./ExternalePrenotazioniPresaInCaricoListPage.vue?vue&type=script&lang=js"
export * from "./ExternalePrenotazioniPresaInCaricoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports